const FONT_STACK = [
	'Inter',
	'-apple-system',
	'BlinkMacSystemFont',
	'Segoe UI',
	'Roboto',
	'Helvetica Neue',
	'Arial',
	'Noto Sans',
	'sans-serif',
	'Apple Color Emoji',
	'Segoe UI Emoji',
	'Segoe UI Symbol',
	'Noto Color Emoji'
]
	.map((fontName) => (fontName.includes('') ? `"${fontName}"` : fontName))
	.join(', ');

const STRIPE_API_VERSION = '2022-08-01';

class PaymentGateway {
	constructor(paymentGatewayKey, paymentGatewayAccountId, provider) {
		if (!Stripe) {
			// eslint-disable-next-line no-console
			console.error('The Stripe library has not been loaded into the page.');
		}
		if (!paymentGatewayKey) {
			// eslint-disable-next-line no-console
			console.error(`The ${provider}  payment provider gateway key has not been defined.`);
		}

		if (['clubspark', 'lta_payment'].includes(provider)) {
			this._stripe = paymentGatewayAccountId
				? new Stripe(paymentGatewayKey, { stripeAccount: paymentGatewayAccountId, apiVersion: STRIPE_API_VERSION })
				: new Stripe(paymentGatewayKey, { apiVersion: STRIPE_API_VERSION });
			this.createPaymentMethod = this._stripe.createPaymentMethod;
			this.paymentRequest = this._stripe.paymentRequest;
			this.confirmCardPayment = this._stripe.confirmCardPayment;
			this.elements = this._stripe.elements();
			this.handleCardAction = this._stripe.handleCardAction;
		}
	}
}

// eslint-disable-next-line consistent-return
export const getPaymentGatewayInstance = (provider, paymentGateway_LTA) => {
	const { basket, checkout } = window.lta[provider];

	if(paymentGateway_LTA) {
		return new PaymentGateway(
			paymentGateway_LTA,
			checkout.paymentGatewayAccountId,
			provider,
		);
	}

	if (['clubspark', 'lta_payment'].includes(provider)) {
		if (!checkout.paymentGateway && basket.totalCost !== 0) {
			checkout.paymentGateway = new PaymentGateway(
				checkout.paymentGatewayKey,
				checkout.paymentGatewayAccountId,
				provider
			);
		}
		return checkout.paymentGateway;
	} else if (!provider) {
		return 'No provider found';
	}
};

export const elementClasses = {
	base: 'stripe-input-wrapper',
	empty: 'stripe-input-wrapper__empty',
	focus: 'stripe-input-wrapper__focus',
	invalid: 'stripe-input-wrapper__error'
};

export const elementStyles = {
	base: {
		'color': '#2D343C',
		'fontFamily': FONT_STACK,
		'fontSize': '16px',
		'::placeholder': {
			color: '#CDD4D8'
		}
	},
	invalid: {
		iconColor: '#DB3624',
		color: '#DB3624'
	}
};
